import quoteAggregatorsData from "./quote-aggregators.json"; 

interface QuoteAggregator {
    id: string;
    name: string;
}

export const getQuoteAggregatorNames = (): string[] => {
    return quoteAggregatorsData.quoteAggregators.map(aggregator => aggregator.name);
};